import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flower2, Cherry, Sprout } from 'lucide-react';
import { ServiceType } from '../../types/api';

interface ServiceTypeSectionProps {
  serviceType: ServiceType;
  setServiceType: (type: ServiceType) => void;
}

const ServiceTypeSection: React.FC<ServiceTypeSectionProps> = ({
  serviceType,
  setServiceType
}) => {
  const { t } = useTranslation();

  const handleServiceTypeChange = () => {
    // Cycle through all three services: flower → fruit → cat_grass → flower
    if (serviceType === 'flower') {
      setServiceType('fruit');
    } else if (serviceType === 'fruit') {
      setServiceType('cat_grass');
    } else {
      setServiceType('flower');
    }
  };

  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-sm mb-2">
      <div className="p-4 flex items-center justify-between">
        <div className="flex items-center">
          <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center mr-3">
            {serviceType === 'flower' ? (
              <Flower2 className="h-4 w-4 text-yellow-600" />
            ) : serviceType === 'fruit' ? (
              <Cherry className="h-4 w-4 text-yellow-600" />
            ) : (
              <Sprout className="h-4 w-4 text-yellow-600" />
            )}
          </div>
          <div>
            <p className="text-sm font-medium text-gray-700">
              {t('subscription.serviceType.title')}
            </p>
            <p className="text-xs text-gray-500">
              {serviceType === 'flower' 
                ? t('subscription.serviceType.flower') 
                : serviceType === 'fruit'
                ? t('subscription.serviceType.fruit')
                : t('subscription.serviceType.cat_grass')}
            </p>
          </div>
        </div>
        <button
          onClick={handleServiceTypeChange}
          className="text-xs text-yellow-600 font-medium"
        >
          {t('subscription.serviceType.change')}
        </button>
      </div>
    </div>
  );
};

export default ServiceTypeSection; 